module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAMFBMVEUAAAB1st2NwOOeyeff7ffd7Pfo8vmiy+iAuOCMv+OBueHi7/jq8/qKvuKAueCax+Z7M7mHAAAAAXRSTlMAQObYZgAAADhJREFUeAFjwASMgmAgAGIIKUIZJsFQhlgihFHYOUscxJDcM1Hy9EQ4Ayy18p44qmLBL/4oBuIGAFcED4xEq+d9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/FM.png
// module id = 1139
// module chunks = 0